if (!customElements.get('bvj-tile-choices')) {
  customElements.define('bvj-tile-choices', class extends HTMLElement {
    async connectedCallback() {
      const calculator = this.closest('bvj-tile-calculator, bvj-sartoria-calculator');
      if (!calculator) return;
      await customElements.whenDefined(calculator.localName);
      if (!this.isConnected || !calculator.selects?.length || !calculator.variant) return;
      if (!this.groups) this.enhance();
      this.observer ||= new MutationObserver(() => this.sync());
      this.groups.forEach(({ select }) => this.observer.observe(select, {
        attributes: true,
        subtree: true,
        attributeFilter: ['disabled', 'selected']
      }));
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    enhance() {
      this.groups = Array.from(this.querySelectorAll('.bvj-config__group')).map(group => {
        const select = group.querySelector('select');
        const choices = group.querySelector('.bvj-config__choices');
        const buttons = Array.from(select.options).map(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'bvj-config__choice';
          button.setAttribute('role', 'radio');
          button.textContent = option.textContent;
          button.dataset.value = option.value;
          return button;
        });
        choices.replaceChildren(...buttons);
        choices.addEventListener('click', event => {
          const button = event.target.closest('.bvj-config__choice');
          if (!button || button.disabled || !choices.contains(button)) return;
          this.choose(select, button);
        });
        choices.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          const enabled = buttons.filter(button => !button.disabled);
          const current = enabled.indexOf(event.target.closest('.bvj-config__choice'));
          if (current < 0 || !enabled.length) return;
          event.preventDefault();
          let index;
          if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = enabled.length - 1;
          else index = (current + (event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1) + enabled.length) % enabled.length;
          enabled[index].focus();
          this.choose(select, enabled[index]);
        });
        select.addEventListener('change', () => this.sync());
        return { select, choices, buttons };
      });
      this.sync();
      this.groups.forEach(({ select, choices }) => {
        choices.hidden = false;
        select.hidden = true;
      });
    }

    choose(select, button) {
      if (select.value === button.dataset.value) return;
      select.value = button.dataset.value;
      this.sync();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    sync() {
      this.groups.forEach(({ select, buttons }) => {
        const focusable = buttons.find((button, index) => select.options[index].selected && !select.options[index].disabled && !select.disabled)
          || buttons.find((button, index) => !select.options[index].disabled && !select.disabled);
        buttons.forEach((button, index) => {
          const option = select.options[index];
          button.disabled = select.disabled || option.disabled;
          button.classList.toggle('is-selected', option.selected);
          button.setAttribute('aria-checked', String(option.selected));
          button.setAttribute('aria-disabled', String(button.disabled));
          button.tabIndex = button === focusable ? 0 : -1;
        });
      });
    }
  });
}
